import React, { useState, useEffect, useContext } from "react";
import "./Screens.scss";
import { AppContext } from "../../Context/AppContext";
import axios from "axios";

// Material UI
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Button from "@mui/material/Button";
import Alert from "@mui/material/Alert";
// Custom Plugins
import { roundNearestX } from "../../Plugins/HelperFunctions";

const Screen10 = () => {
  const {
    screensData,
    setActiveScreen,
    offeredPrice,
    setOfferedPrice,
    setShowSpinner,
  } = useContext(AppContext);
  const [isCarNew, setIsCarNew] = useState(false);
  const [model, setModel] = useState(null);
  const baseUrl = (/local/.test(window.location.href) ? "http://localhost:3002": "https://secure-temple-73063.herokuapp.com") || "https://carcalculator.herokuapp.com";


  function getQueryVariable(variable) {
    var query = window.location.search.substring(1);
    var vars = query.split('&');
    for (var i = 0; i < vars.length; i++) {
        var pair = vars[i].split('=');
        if (decodeURIComponent(pair[0]) == variable) {
            return decodeURIComponent(pair[1]);
        }
    }
    return '';
  }

  React.useEffect(() => {
    const offeredPrice = getQueryVariable("offeredPrice");
    const model = getQueryVariable("model");

    if (offeredPrice) {
      setTimeout(() => {
        setShowSpinner(false);
      }, 1000);
      setOfferedPrice(offeredPrice);
    }

    if (model) {
      setModel(decodeURIComponent(model.replace(/\+/g, '%20')));
    } 



  }, []);

  const saveOffer = async () => {
      let doc = {};
      for (let x in screensData) {
          doc = {...screensData[x], ...doc};
      }
      doc.unsub = screensData.unsub;
      console.log("UNSUB>>", doc.unsub)
    
    console.log("SCREENS DATA", doc);
    doc.offeredPrice = offeredPrice;
    const baseUrl = (/local/.test(window.location.href) ? "http://localhost:3002": "https://secure-temple-73063.herokuapp.com") || "https://carcalculator.herokuapp.com";
    axios.post(baseUrl + "/offer", doc)
    .then(d => {
      screensData.offerId = d.data.offer._id;
    });

    //if (window.confirm()) {
    //  setActiveScreen((prevactiveScreen) => prevactiveScreen - 1);
    //}
  }

  const calculateOffer = () => {
    const obj = {
      year: screensData.screen1.year,
      make: screensData.screen1.make,
      model: screensData.screen1.model,
    };
    setShowSpinner(true);
    axios.post(`${baseUrl}/curb-weight`, obj).then((res) => {
      setShowSpinner(false);
      const curbWeight = res.data.data;

      const pricePerPoundFirst2000 = 0.16;
      const pricePerPoundTo3000 = 0.135;
      const pricePerPoundAfter3000 = 0.11;
      let finalPrice = 0;
      let currentYear = new Date().getFullYear();

      if (curbWeight < 2000) {
        finalPrice = pricePerPoundFirst2000 * curbWeight;
      } else if (curbWeight < 3000) {
        finalPrice =
          2000 * pricePerPoundFirst2000 +
          (curbWeight - 2000) * pricePerPoundTo3000;
      } else if (curbWeight >= 3000) {
        finalPrice =
          2000 * pricePerPoundFirst2000 +
          1000 * pricePerPoundTo3000 +
          (curbWeight - 3000) * pricePerPoundAfter3000;
      }

      if (screensData.screen7.engineTransmission === 0) {
        finalPrice -= 160;
      }

      if (screensData.screen8.catalyticConverter === 0) {
        finalPrice -= 160;
      }

      /* Year Based Increments */
      // if (currentYear - screensData.screen1.year <= 12) {
      //   finalPrice += 100;
      // } else if (currentYear - screensData.screen1.year <= 10) {
      //   finalPrice += 200;
      // } else if (currentYear - screensData.screen1.year <= 8) {
      //   finalPrice += 300;
      // } else if (currentYear - screensData.screen1.year <= 6) {
      //   finalPrice += 600;
      // }

      if (currentYear - screensData.screen1.year <= 6) {
        finalPrice += 600;
      } else if (currentYear - screensData.screen1.year <= 8) {
        finalPrice += 300;
      } else if (currentYear - screensData.screen1.year <= 10) {
        finalPrice += 200;
      } else if (currentYear - screensData.screen1.year <= 12) {
        finalPrice += 100;
      }

      /* Brand Based Increaments */
      if (
        screensData.screen1.make === "HONDA" ||
        screensData.screen1.make === "TOYOTA"
      ) {
        finalPrice += 30;
      } else if (
        screensData.screen1.make === "AUDI" ||
        screensData.screen1.make === "BMW"
      ) {
        finalPrice += 40;
      }

      if (finalPrice > 0) {
				finalPrice += 25;
			}
			if (finalPrice < 550) {
				finalPrice += 20;
			}

      /* To Round Price To Nearest Divisor Of 10 */
      finalPrice = roundNearestX(finalPrice, 10);

      /* If Prie Is Zero */
      if (finalPrice < 0) {
        finalPrice = 0;
      }

      setOfferedPrice(finalPrice);
      //setShowSpinner(false);

      saveOffer();
    });
  };

  useEffect(() => {
    const currentYear = new Date().getFullYear();

    if (Number(currentYear) - Number(screensData.screen1.year) < 7) {
      setIsCarNew(true);
    } else {
      setIsCarNew(false);
    }

    calculateOffer();
    // eslint-disable-next-line
  }, [screensData]);

  const submitForm = (e) => {
    e.preventDefault();
    setActiveScreen((prevactiveScreen) => prevactiveScreen + 1);
  };

  return (
    <div className="screen">
      <form onSubmit={submitForm}>
        <Box className="screen__wrapper">
          <Typography
            variant="h2"
            component="h2"
            align="center"
            style={{ color: "var(--secondaryColor)" }}
          >
            ${offeredPrice}
          </Typography>

          <Typography
            variant="h5"
            component="h5"
            align="center"
            style={{ color: "var(--secondaryColor)" }}
          >
            {model}
            {screensData &&
              `${screensData.screen1.year} ${screensData.screen1.make} ${screensData.screen1.model}`}
          </Typography>

          {isCarNew && (
            <Alert severity="info">
              Since your vehicle is relatively new, we may be able to give you
              an even better offer on the phone. Please give us a call to
              receive your best offer.
            </Alert>
          )}
          {(offeredPrice && offeredPrice === 0) ? (
            <Alert severity="info">
              We can offer you free pickup for your vehicle without charge!
            </Alert>
          ) : null}

          <Button variant="contained" color="primary" type="submit">
            Accept Offer
          </Button>
        </Box>
      </form>
    </div>
  );
};

export default Screen10;
